import { boolToToggleValue, Toggles } from '../../../_components/Toggles';

type BooleanFieldProps = {
  value: boolean | undefined;
  onChange: (value: boolean) => void;
  onClear: () => void;
};

export const BooleanField = ({
  value,
  onChange,
  onClear,
}: BooleanFieldProps) => {
  return (
    <Toggles
      value={boolToToggleValue(value)}
      onChange={(toggleValue) => {
        if (toggleValue === 'none') {
          onClear();
        } else {
          onChange(toggleValue === 'allowed');
        }
      }}
    />
  );
};
